import { createFileRoute } from "@tanstack/react-router";
import { IndiaHub } from "@/components/country/in/IndiaHub";
import { CountrySwitcher } from "@/components/country/CountrySwitcher";
import { IndiaShareCenter } from "@/components/growth/IndiaShareCenter";
import { IndiaCommunityFeed } from "@/components/growth/IndiaCommunityFeed";
import { WhatsAppGrowthCTAs } from "@/components/growth/WhatsAppGrowthCTAs";
import { TelegramCtaCard } from "@/components/growth/TelegramCtaCard";
import { Link } from "@tanstack/react-router";
import { listInfluencersByCountry } from "@/lib/growth/influencerRegistry";

export const Route = createFileRoute("/india/")({
  head: () => ({
    meta: [
      { title: "VerseSport India — Join the world's largest football fan movement" },
      { name: "description", content: "Predictions, Nation Wars, ranking and global fan community for India during the World Cup. Mobile-first, WhatsApp-first, Telegram-first." },
      { property: "og:title", content: "VerseSport India — World Cup fan community" },
      { property: "og:description", content: "Predictions, ranking and community for India in the World Cup." },
      { property: "og:url", content: "https://versesport.com/india" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "VerseSport India — World Cup fan community" },
      { name: "twitter:description", content: "Predictions, ranking and community for India in the World Cup." },
    ],
    links: [{ rel: "canonical", href: "https://versesport.com/india" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "VerseSport India",
          url: "https://versesport.com/india",
          inLanguage: "en-IN",
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SportsOrganization",
          name: "VerseSport India — World Cup fan community",
          sport: "Football",
          url: "https://versesport.com/india",
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "Does VerseSport broadcast World Cup matches in India?",
              acceptedAnswer: { "@type": "Answer", text: "No. VerseSport is a second-screen companion to the official broadcast you are already watching on Sony LIV, JioCinema or Star Sports." },
            },
            {
              "@type": "Question",
              name: "How does the India fan community work?",
              acceptedAnswer: { "@type": "Answer", text: "Every prediction, share and challenge adds points to your India ranking and to global Nation Wars." },
            },
            {
              "@type": "Question",
              name: "Will Audio Sync work with my Indian broadcaster?",
              acceptedAnswer: { "@type": "Answer", text: "Yes. Audio Sync aligns VerseSport with any broadcaster so you never get spoilers ahead of the play." },
            },
          ],
        }),
      },
    ],
  }),
  component: IndiaLanding,
});

function IndiaLanding() {
  const influencers = listInfluencersByCountry("IN");
  return (
    <main className="mx-auto max-w-3xl space-y-4 px-3 py-4">
      <div className="flex items-center justify-end"><CountrySwitcher /></div>
      <IndiaHub />
      <IndiaShareCenter />
      <IndiaCommunityFeed />
      <WhatsAppGrowthCTAs nationCode="IN" />
      <TelegramCtaCard country="IN" />
      {influencers.length > 0 && (
        <nav aria-label="India creators" className="rounded-2xl border border-border bg-background/60 p-3">
          <div className="mb-1 text-[11px] font-black uppercase tracking-widest" style={{ color: "oklch(0.72 0.16 60)" }}>
            India creators
          </div>
          <ul className="flex flex-wrap gap-2 text-[12px] font-bold">
            {influencers.map((i) => (
              <li key={i.slug}>
                <Link
                  to="/india/influencer/$slug"
                  params={{ slug: i.slug }}
                  className="rounded-full border border-border px-3 py-1 hover:bg-accent"
                >
                  {i.emoji} {i.displayName}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      )}
      <p className="px-1 text-[10px] leading-snug text-muted-foreground">
        VerseSport does not broadcast or redistribute any signal. We accompany the
        official broadcast you are already watching. Mentioned brands belong to
        their respective owners.
      </p>
    </main>
  );
}